import React from "react";
import { Link } from "react-router-dom";

const BackArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="12 19 5 12 12 5" />
  </svg>
);

const PrivacyPolicy: React.FC = () => {
  return (
    <main className="mx-auto px-4 py-8">
      <Link
        to="/dashboard"
        className="inline-flex items-center gap-2 text-[#003366] font-medium mb-6 hover:bg-[#003366] rounded-md px-3 py-2 hover:text-white transition-colors duration-200"
      >
        <BackArrow />
        Back to Dashboard
      </Link>

      <h1 className="text-3xl font-bold text-[#003366] text-center mb-8">
        Privacy Policy
      </h1>

      <p className="text-gray-700 text-base leading-relaxed mb-4">
        We do not collect personal information, like names or addresses, when
        you visit our website. If you choose to provide that information to us,
        it's only used to fulfill your request for information.
      </p>
      <p className="text-gray-700 text-base leading-relaxed mb-4">
        We do collect some technical information when you visit to make your
        visit seamless. The section below explains how we handle and collect
        technical information when you visit our website.
      </p>

      <h2 className="text-lg font-semibold text-[#1F2937] mt-6 mb-3">
        Information collected and stored automatically
      </h2>
      <p className="text-gray-700 text-base leading-relaxed mb-3">
        When you browse, read pages, or download information on website of D/o
        SJ&amp;E, we automatically gather and store certain technical
        information about your visit. This information never identifies who you
        are. The information we collect and store about your visit is listed
        below:
      </p>
      <ul className="text-gray-700 text-base leading-relaxed list-disc pl-6 space-y-1 mb-4">
        <li>
          The IP address (IP address is a number that is automatically assigned
          to your computer whenever you're surfing the web) from which you
          access our website.
        </li>
        <li>
          The type of browser (such as Firefox, Netscape, or Internet Explorer)
          and operating system (Windows, Unix) used to access our site
        </li>
        <li>The date and time you accessed our site</li>
        <li>The pages/URLs you have visited and</li>
      </ul>
      <p className="text-gray-700 text-base leading-relaxed mb-4">
        This information is only used to help us make the site more useful for
        you. With this data, we learn about the number of visitors to our site
        and the types of technology our visitors use. We never track or record
        information about individuals and their visits.
      </p>

      <h2 className="text-lg font-semibold text-[#1F2937] mt-6 mb-3">Cookies</h2>
      <p className="text-gray-700 text-base leading-relaxed mb-4">
        When you visit some websites, they may download small pieces of software
        on your computer/browsing device known as cookies. Some cookies collect
        personal information to recognize your computer in the future. We only
        use non-persistent cookies or "per-session cookies".
      </p>
      <p className="text-gray-700 text-base leading-relaxed mb-4">
        Per-session cookies serve technical purposes, like providing seamless
        navigation through this website. These cookies do not collect personal
        information on users and they are deleted as soon as you leave our
        website.
      </p>
      <p className="text-gray-700 text-base leading-relaxed mb-4">
        The cookies do not permanently record data and they are not stored on
        your computer's hard drive. The cookies are stored in memory and are
        only available during an active browser session. Again, once you close
        your browser, the cookie disappears.
      </p>

      <h2 className="text-lg font-semibold text-[#1F2937] mt-6 mb-3">
        If you send us personal information
      </h2>
      <p className="text-gray-700 text-base leading-relaxed mb-4">
        We do not collect personal information for any purpose other than to
        respond to you (for example, to respond to your questions or provide
        subscriptions you have chosen). If you choose to provide us with
        personal information— like filling out a Contact Us form, with an e-mail
        address and pin code, and submitting it to us through the website—we use
        that information to respond to your message, and to help get you the
        information you've requested. We only share the information you give us
        with another government agency if your question relates to that agency,
        or as otherwise required by law.
      </p>
      <p className="text-gray-700 text-base leading-relaxed">
        Our website never collects information or creates individual profiles
        for commercial marketing. While you MUST provide an e-mail address for a
        localized response to any incoming questions or comments to us, we
        recommend that you do NOT include any other personal information.
      </p>
    </main>
  );
};

export default PrivacyPolicy;
